import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import parameterReducer from "./parameterSlice";
import { configureStore } from "@reduxjs/toolkit";

const persistConfig = {
    key: "root",
    storage: storage,
};

const persistedReducer = persistReducer(persistConfig, parameterReducer);

const store = configureStore({
    reducer: {
        parameter: persistedReducer,
    },
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Menonaktifkan serializableCheck jika diperlukan untuk redux-persist
        }),
});

const persistor = persistStore(store);

export { store, persistor };
